import { useState } from "react";
import {
  createBanner,
  updateBanner,
  getBanners,
  deleteBanner,
  reorderBanner
} from "api/banner.api";

export function useBanners() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadBanners = async () => {
    setLoading(true);
    try {
      const res = await getBanners();
      setData(res.data || []);
    } finally {
      setLoading(false);
    }
  };

  const load = async (bannerType) => {
    if (!bannerType) return; 

    setLoading(true);
    try {
      const company_id = localStorage.getItem("company_id");

      const res = await getBanners({
        bannerType,
        company_id,
      });

      setData(res.data || []);
    } finally {
      setLoading(false);
    }
  };

  const reload = (bannerType) => load(bannerType);

  const addBanner = async (payload) => {
      return await createBanner(payload);
    };
  
    const editBanner = async (id, payload) => {
      return await updateBanner(id, payload);
    };

    const reorder = async (orders, bannerType) => {
      await reorderBanner(orders); 
      await load(bannerType);
    };


  const removeBanner = async (id, payload) => {
    await deleteBanner(id, payload);
  };

  return { data, loading, load, loadBanners, removeBanner, addBanner, editBanner, reload, reorder };
}
